// CreateNotificacionPage.tsx
import { SaveNotificacion } from "../../components";

export default function CreateNotificacionPage() {
  return <SaveNotificacion titulo="Crear Notificación" />;
}
